import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './TeamItem.scss';

class TeamItem extends Component {
  render () {
    const { keyArr, itemObj
      , isAmount, isIncomeAmount } = this.props;
    const itemArr = [
      {
        name: keyArr[0],
        value: isAmount || isIncomeAmount ? itemObj.allAmount : itemObj.allCount,
      }, {
        name: keyArr[1],
        value: isAmount || isIncomeAmount ? itemObj.monthAmount : itemObj.monthCount,
      }, {
        name: keyArr[2],
        value: isIncomeAmount ? itemObj.todayAmount : itemObj.todayCount,
      }
    ];

    return (
      <div className='teamItem'>
        <ul>
          {
            itemArr.map((item, index) => {
              if (!(isAmount && index === 2)) {
                return <li key={index} className={isAmount && index === 1 ? 'right' : ''}>
                  <div className='income-data'>
                    <div>{item.name}</div>
                    <div>{this.props.isHomeHide ? '****' : item.value}</div>
                  </div>
                  {index !== 2 && !(isAmount && index === 1) ? <div className={`${isAmount && index === 0 ? 'line-center' : ''} line`}></div> : ''}
                </li>
              }
              return '';
            })
          }
        </ul>
      </div>
    )
  }
}

TeamItem.propTypes = {
  itemObj: PropTypes.object.isRequired,
  keyArr: PropTypes.array.isRequired,
  isHomeHide: PropTypes.bool, //是否是首页显示隐藏
  isAmount: PropTypes.bool, //区分是数量还是金额
  isIncomeAmount: PropTypes.bool
}

TeamItem.defaultProps = {
  itemObj: {
    allCount: '',
    monthCount: '',
    todayCount: '',
    allAmount: '',
    monthAmount: ''
  }
}

export default TeamItem;
